import React, { useState } from "react";

import { Grid, Typography, InputAdornment, CardMedia } from "@material-ui/core";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import backgroundImg from "../assets/images/backgroundImg.png";
import imgUrl from "../../components/assets/images/sparrow_white.png";
import SnackbarComponent from "../CommonComponent/Snackbar/Snackbar";
import {
  StyledImg,
  StyledPaper,
  StyledMainDiv,
  StyledTextField,
  StyledNewUserDiv,
  StyledButtonSignIn,
  StyledDivider,
  StyledFormDataRememberAndForgotDiv,
} from "./login.css";

export default function Login() {
  const { login } = useAuth();

  const [showSnackbar, setShowSnackbar] = useState({
    open: false,
    type: "success",
    msg: "",
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visibility, setVisibility] = useState(true);

  /** onSnackbarClose() is trigger when snackbar close automatically / manually */
  const onSnackbarClose = () => {
    setShowSnackbar({
      ...showSnackbar,
      open: false,
      type: "error",
      msg: "",
    });
  };

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);
      await login(email, password);
      history.push("/");
    } catch {
      setShowSnackbar({ open: true, type: "error", message: "error" });
    }

    setLoading(false);
  }

  const handleVisible = () => {
    setVisibility((prev) => !prev);
  };

  const ShowHide = () => {
    if (visibility) {
      return <VisibilityOffIcon onClick={() => handleVisible()} />;
    }
    return <VisibilityIcon onClick={() => handleVisible()} />;
  };

  return (
    <>
    {/* Add logo in login screen - top left */}
    {/* <Grid container>
        <Grid item xs={6}> */}
          <CardMedia
            component="img"
            image={imgUrl}
            alt={"img"}
            style={{
              top: "-1.5rem",
              width: "10%",
              paddingLeft: '10px',
              position: "relative",
              marginBottom: '0'
            }}
          />
        {/* </Grid>
      </Grid> */}
      <StyledMainDiv>
        {/* <StyledImg src={backgroundImg} alt="dd" /> */}
        <Grid container style={{ justifyContent: "center", paddingLeft: '8%' }}>
          <Grid item md={6} sm={6} xs={12}>
            <StyledPaper style={{backgroundColor: '#e8f0fe'}} >
              <StyledMainDiv>
                <Typography variant="h5">Sign In</Typography>
                <p>Enter Username and Password</p>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <Grid container>
                    <Grid item xs={12}>
                      <StyledTextField
                        variant="outlined"
                        type="email"
                        size="small"
                        placeholder="Email"
                        autoComplete="off"
                        error
                        id="outlined-error"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MailOutlineIcon />
                            </InputAdornment>
                          ),
                          endAdornment: <InputAdornment position="end" />,
                        }}
                        onChange={(e) => {
                          setEmail(e.target.value.trim());
                        }}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <StyledTextField
                        variant="outlined"
                        autoComplete="off"
                        type={visibility ? "password" : "email"}
                        size="small"
                        placeholder="Enter Password"
                        value={password}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <LockOpenIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              {ShowHide()}
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => {
                          setPassword(e.target.value.trim());
                        }}
                        required
                      />
                    </Grid>
                    <StyledFormDataRememberAndForgotDiv>
                      <Grid item xs={12}>
                        <Link
                          sx={{ cursor: "pointer" }}
                          onClick={() => {
                            history.push("forgot-password");
                          }}
                        >
                          Forget Password?
                        </Link>
                      </Grid>
                    </StyledFormDataRememberAndForgotDiv>
                  </Grid>
                  <div>
                    <StyledButtonSignIn variant="contained" type="submit">
                      Sign In
                    </StyledButtonSignIn>
                  </div>
                </form>

                {/* <StyledDivider>
                  <span>or</span>
                </StyledDivider>

                <StyledNewUserDiv>
                  <Typography variant="h6" gutterBottom component="div">
                    New user?
                    <Link
                      onClick={() => {
                        history.push("signup");
                      }}
                    >
                      Register here
                    </Link>
                  </Typography>
                </StyledNewUserDiv> */}
              </StyledMainDiv>
            </StyledPaper>
          </Grid>
        </Grid>
      </StyledMainDiv>
      <SnackbarComponent
        open={showSnackbar.open}
        type={showSnackbar.type}
        message={showSnackbar.message}
        onClose={onSnackbarClose}
      />
    </>
  );
}
